/**
 * Statistics the Wallie board reports through the scout's verbose time-service string, embedded as JSON after
 * "Wallie: " and ended by the next " | " separator, the way Commander reads them.
 */
export interface WallieStats {
  droppedFramesLastMinute?: number;
  droppedFramesLastHour?: number;
  droppedFramesLast24h?: number;
  /** Board temperature in °C. */
  temperature?: number;
  status?: string;
  [key: string]: unknown;
}

const MARKER = "Wallie: ";

/** The Wallie statistics from a scout's time-service details, or undefined when the string has none or is broken. */
export const parseWallieStats = (details: string | null | undefined): WallieStats | undefined => {
  if (!details) {
    return undefined;
  }
  const start = details.indexOf(MARKER);
  if (start < 0) {
    return undefined;
  }
  const json = details.slice(start + MARKER.length).split("|")[0].trim();
  try {
    const parsed: unknown = JSON.parse(json);
    return parsed !== null && typeof parsed === "object" ? (parsed as WallieStats) : undefined;
  } catch (e) {
    return undefined;
  }
};

const count = (value: number | undefined) => (typeof value === "number" ? value : "–");

/** "0 min · 0 hour · 0 day": frames dropped in the last minute, hour and 24 hours. */
export const droppedFramesText = (stats: WallieStats) =>
  `${count(stats.droppedFramesLastMinute)} min · ${count(stats.droppedFramesLastHour)} hour · ${count(stats.droppedFramesLast24h)} day`;
